import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Campaign } from '../models/api.models';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class CampaignsService {
  constructor(private readonly api: ApiService) {}

  list(): Observable<Campaign[]> {
    return this.api.get<Campaign[]>('/campaigns');
  }

  create(payload: Campaign): Observable<Campaign> {
    return this.api.post<Campaign>('/campaigns', payload);
  }

  dispatch(id: number): Observable<{ message: string }> {
    return this.api.post<{ message: string }>(`/campaigns/${id}/dispatch`, {});
  }
}
